import { TActionTypes, IAction } from '@Root/types'

export const LabelActionTypes = {
  FETCH_LABELS: '@@label/FETCH_LABEL',
  FETCH_LABELS_FAILURE: '@@label/FETCH_LABELS_FAILURE',
  FETCH_LABELS_SUCCESS: '@@label/FETCH_LABELS_SUCCESS',
  CREATE_LABEL: '@@label/CREATE_LABEL',
  CREATE_LABEL_FAILURE: '@@label/CREATE_LABEL_FAILURE',
  CREATE_LABEL_SUCCESS: '@@label/CREATE_LABEL_SUCCESS',
  CHANGE_SELECTED_LABELS: '@@label/CHANGE_SELECTED_LABELS',
  SET_LABEL_SELECTION: '@@label/SET_LABEL_SELECTION',
  DELETE_PROJECT_LABELS: '@@label/DELETE_PROJECT_LABELS',
  DELETE_PROJECT_LABELS_FAILURE: '@@label/DELETE_PROJECT_LABELS_FAILURE',
  DELETE_PROJECT_LABELS_SUCCESS: '@@label/DELETE_PROJECT_LABELS_SUCCESS',
  CREATE_PROJECT_LABELS: '@@label/CREATE_PROJECT_LABELS',
  CREATE_PROJECT_LABELS_FAILURE: '@@label/CREATE_PROJECT_LABELS_FAILURE',
  CREATE_PROJECT_LABELS_SUCCESS: '@@label/CREATE_PROJECT_LABELS_SUCCESS',
  RENAME_LABEL: '@@label/RENAME_LABEL',
  RENAME_LABEL_FAILURE: '@@label/RENAME_LABEL_FAILURE',
  RENAME_LABEL_SUCCESS: '@@label/RENAME_LABEL_SUCCESS',
  DELETE_LABEL: '@@label/DELETE_LABEL',
  DELETE_LABEL_FAILURE: '@@label/DELETE_LABEL_FAILURE',
  DELETE_LABEL_SUCCESS: '@@label/DELETE_LABEL_SUCCESS',
}

export interface ILabelState {
  readonly labels: ILabel[]
  readonly selectedLabelIds: number[]
  readonly hasLoadedInitially: boolean
  readonly loading: boolean
}

export interface ILabel {
  readonly id: number
  readonly attributes: ILabelAttributes
}

export interface ILabelData {
  readonly id: string
  readonly type: 'label'
  readonly attributes: ILabelAttributes
}

export interface ILabelAttributes {
  readonly caption: string
  readonly projectIds: string[]
  readonly updatedAt: string
  readonly createdAt: string
}

export interface IFetchLabelsPayload {
  workspaceId: number
}

export interface IFetchLabelsSuccessResponseBody {
  readonly data: ILabelData[]
}

export interface ICreateLabelPayload {
  readonly workspaceId: number
  readonly caption: string
  readonly projectIdsForAssignment?: string[]
}

export interface IChangeSelectedLabelsPayload {
  readonly labelId: number
  readonly selectLabel: boolean
}

export interface ICreateProjectLabelsPayload {
  readonly labelId: number
  readonly selectedProjectIds: string[]
}

export type ICreateProjectLabelsSuccessPayload = ICreateProjectLabelsPayload

export type IDeleteProjectLabelsPayload  = ICreateProjectLabelsPayload

export type IDeleteProjectLabelsSuccessPayload = IDeleteProjectLabelsPayload

export interface IEditLabelPayload {
  readonly labelId: number
  readonly labelName: string
}

export interface IRenameLabelPayload {
  readonly labelId: number
  readonly caption: string
}

export type IRenameLabelSuccessPayload = IRenameLabelPayload

export type IDeleteLabelPayload = IRenameLabelPayload

export type IDeleteLabelSuccessPayload = IDeleteLabelPayload

export interface ICreateLabelSuccessResponseBody {
  readonly data: ILabelData
}

export interface ISetLabelSelectionPayload {
  readonly labelIds: number[]
  readonly suppressProjectsFetch?: boolean
}

export type TLabelActionTypes =
  TActionTypes |
  IAction<ICreateLabelPayload> |
  IAction<IFetchLabelsSuccessResponseBody> |
  IAction<IChangeSelectedLabelsPayload> |
  IAction<ICreateProjectLabelsPayload> |
  IAction<ICreateProjectLabelsSuccessPayload> |
  IAction<IDeleteProjectLabelsSuccessPayload> |
  IAction<IRenameLabelSuccessPayload> |
  IAction<IDeleteLabelSuccessPayload> |
  IAction<ICreateLabelSuccessResponseBody> |
  IAction<ISetLabelSelectionPayload>
